import createStyledEnhancer from "../helpers/createStyledEnhancer";
import { composeEnhancers } from "../helpers";
import isObject from "../../helpers/isObject";
export var fontSizeTransformation = function fontSizeTransformation(property, _ref) {
  var themeValue = _ref.themeValue;

  if (themeValue && isObject(themeValue) && themeValue !== null && themeValue !== void 0 && themeValue.fontSize) {
    return themeValue.fontSize;
  }

  return property;
};
export var fontSize = createStyledEnhancer({
  name: "fontSize",
  keys: ["font.sizes"],
  transformation: fontSizeTransformation
});
export var lineHeight = createStyledEnhancer({
  name: "lineHeight"
});
export var fontWeight = createStyledEnhancer({
  name: "fontWeight",
  addPx: false,
  transformation: function transformation(value) {
    return value === "medium" ? "500" : String(value);
  }
});
export var fontStyle = createStyledEnhancer({
  name: "fontStyle"
});
export var fontFamily = createStyledEnhancer({
  name: "fontFamily"
});
export var letterSpacing = createStyledEnhancer({
  name: "letterSpacing"
});
export var textAlign = createStyledEnhancer({
  name: "textAlign"
});
export var verticalAlign = createStyledEnhancer({
  name: "verticalAlign"
});
export var userSelect = createStyledEnhancer({
  name: "userSelect"
});
export var text = composeEnhancers(fontSize, lineHeight, fontWeight, fontStyle, fontFamily, letterSpacing, textAlign, verticalAlign, userSelect);
/** Пропсы, которые стайлед будет пытаться преобразовать в атрибуты. Нужны для фильтрации */

export var textPropsNoForward = ["fontSize", "lineHeight", "fontWeight", "fontStyle", "fontFamily", "letterSpacing", "verticalAlign", "userSelect"];